/**
 * Collections API call, maps to the Django endpoint in api/urls.py.
 */
import api from './client';

/** Returns { collection } — a single collection and its products by title (handle). */
export const fetchCollection = (handle) => api.get(`/api/collections/${encodeURIComponent(handle)}/`);